import { store } from '../context/NotificationContext';

export const handleSessionExpiry = async (response) => {
  // First check if it's a successful response
  if (response.status === 'success') {
    return false;  // Not expired, legitimate response
  }

  // Then check for session expiry conditions
  if (
    response.error_code === 40000 || 
    (response.message && response.message.toLowerCase().includes('session expired'))
  ) {
    console.log('Session expiry detected:', response);
    
    return new Promise((resolve) => {
      // Show notification
      store.showNotification('SESSION_EXPIRED', {
        message: 'Your session has expired. Please login again.'
      });

      // Wait for notification duration (3 seconds) before clearing and redirecting
      setTimeout(() => {
        localStorage.clear();
        window.location.reload();
        resolve(true);
      }, 3000);  // Match with PopupNotification autoHideDuration
    });
  }

  return false;  // Not a session expiry case
}; 